import * as React from "react";
const SvgFiRr2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M20 24H6.501a2.5 2.5 0 0 1-2.198-1.311 2.52 2.52 0 0 1 .113-2.579c1.232-1.877 3.602-3.06 6.11-4.312 4.085-2.04 7.944-3.965 7.422-8.681-.317-2.87-2.931-5.118-5.95-5.118-3.309 0-6 2.691-6 6a1 1 0 0 1-2 0C4 3.589 7.59 0 12 0c4.09 0 7.502 2.966 7.938 6.898.675 6.102-4.422 8.646-8.517 10.69-2.26 1.128-4.396 2.194-5.332 3.62a.5.5 0 0 0-.025.531.48.48 0 0 0 .438.26h13.499a1 1 0 0 1 0 2z"
    />
  </svg>
);
export default SvgFiRr2;
